const variantName = 'heroV2a'

export default {
  [variantName]: {
    // ?============================
    // ?======  Containers =========
    // ?============================
    hero: {
      height: '100vh',
      width: '100%',
      display: 'block',
      position: 'relative',
      color: 'light',

      // TODO: Give Slider A Wrapper Variant and then put slick styles in there instead of in container
      '.slick-initialized .slick-slide > div': {
        overflow: 'hidden',
        position: 'relative',
        height: '100vh'
      },
      '.slick-slide img': {
        height: '100vh',
        width: '100%',
        position: 'absolute',
        top: '50%',
        left: '50%',
        objectFit: 'cover',
        transform: 'translate(-50%, -50%)'
      },
      '.slick-dots': {
        bottom: '25px'
      },
      '.slick-prev:before, .slick-next:before': {
        color: 'white',
        fontSize: '25px'
      },
      '.slick-dots li button:before': {
        color: 'white',
        fontSize: '10px'
      },
      '.slick-prev, .slick-next': {
        top: 'unset',
        left: 'unset',
        bottom: '20px',
        right: '25px'
      },
      '.slick-next': {
        zIndex: '500'
      },
      '.slick-prev': {
        right: '55px',
        zIndex: '500'
      }
    },

    // ?============================
    // ?======  Box Content ========
    // ?============================

    content: {
      position: 'absolute',
      top: '50%',
      left: '0%',
      transform: 'translate(0%, -50%)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '2rem',
      zIndex: '100',
      boxSizing: 'border-box',
      maxWidth: '767px',
      height: '100%',
      width: ['100%', '', '50%'],
      backgroundColor: 'rgba(0,0,0,0.4)',
      a: {
        display: 'flex',
        width: 'fit-content',
        order: '5'
      }
    },

    // ?============================
    // ?=========  Logos  ==========
    // ?============================

    logoHero: {
      maxHeight: '250px',
      margin: '0 auto 1rem',
      order: '1'
    },

    // ?============================
    // ?======  Text Content =======
    // ?============================
    title: {
      fontSize: 8,
      marginBottom: 3,
      order: '3',
      whiteSpace: 'pre-wrap'
    },
    subtitle: {
      fontSize: 5,
      fontWeight: 'normal',
      marginBottom: 3,
      order: '2',
      whiteSpace: 'pre-wrap'
    },
    text: {
      whiteSpace: 'pre-wrap',
      order: '4',
      color: 'light'
    },

    // ?============================
    // ?========  Buttons  =========
    // ?============================

    ctaButton: {
      margin: '1rem 0',
      padding: '0.75rem 1.5rem',
      backgroundColor: 'primary',
      width: 'fit-content',
      order: '5'
    },

    // ?============================
    // ?=======  Hero Shout  =======
    // ?============================

    // the widget has the same variants as the hero so we can't not pass down a variant name
    shoutWidgetContainer: {
      '.shoutWidget': {
        width: '100%',
        alignItems: 'stretch',
        display: 'flex',
        flexDirection: 'row',
        padding: '0rem',
        '.content': {
          flexDirection: 'column',
          justifyContent: 'center',
          flexGrow: '1',
          paddingLeft: 2,
          paddingRight: 1,
          paddingY: 1,
          width: ['65%', '', '50%'],
          color: 'text'
        },
        '.title': {
          fontSize: 3,
          fontWeight: 'bold',
          color: 'secondary'
        },
        '.text': {
          fontSize: '0.8rem',
          marginY: 1
        },
        '.date': {
          fontSize: 2,
          color: 'secondary',
          fontWeight: 'bold'
        },
        '.imageContainer': {
          width: ['35%', '', '50%'],
          img: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }
        },
        '.shoutCTAS': {
          flexWrap: 'wrap',
          marginBottom: '0.5rem',
          a: {
            margin: '0.5rem 1rem 0.5rem 0rem',
            textDecoration: 'underline',
            fontSize: ['1.25rem', '1.5rem'],
            ':hover': {
              color: 'primary'
            }
          }
        }
      }
    }
  }
}
